import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { DashboardsScreen } from "../components/dashboards/DashboardsScreen";
import { hasPermission } from "../hooks/useCan";
import { meQuery, type Me } from "../hooks/useAuth";
import { queryClient } from "../lib/queryClient";

const searchSchema = z.object({
  /** Which dashboard is open. Absent means "the first one in the list". */
  id: z.string().uuid().optional(),
  preset: z
    .enum(["today", "yesterday", "7d", "30d", "month", "quarter", "ytd", "custom"])
    .default("month"),
  from: z.string().optional(),
  to: z.string().optional(),
});

export const Route = createFileRoute("/_auth/dashboards")({
  staticData: {
    titleKey: "dashboards.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 8,
  },
  validateSearch: searchSchema,
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (!me) return;
    // A dashboard only ever shows report cards, so it rides on the same grant.
    if (!hasPermission(me, "view_reports")) {
      throw redirect({ to: "/clients" });
    }
  },
  component: DashboardsRoute,
});

function DashboardsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <DashboardsScreen
      search={search}
      onSearch={(next) =>
        void navigate({ to: "/dashboards", search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
